import { COMPANIES_UPDATE_SUCCESS, SHOW_PRELOADER, HIDE_PRELOADER } from './actions';

const initialState = {
	loading: true
};

export default (state = initialState, action) => {
	switch (action.type) {

		case SHOW_PRELOADER:
			return {
				...state,
				loading: true
			};

		case HIDE_PRELOADER:
		case COMPANIES_UPDATE_SUCCESS:
			return {
				...state,
				loading: false
			};

		default:
			return state;
	}

};

export const showPreloader = () => {
	return { type: SHOW_PRELOADER };
};

export const hidePreloader = () => {
	return { type: HIDE_PRELOADER };
};


// WEBPACK FOOTER //
// ./src/redux/modules/preloader.js